import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  selector: 'app-tramite-notificaciones',
  templateUrl: './tramite-notificaciones.component.html',
  styleUrls: ['./tramite-notificaciones.component.css']
})
export class TramiteNotificacionesComponent implements OnInit {

  @Input() load: boolean;
  @Input() tmsg: boolean;
  @Output() data = new EventEmitter<any[]>();

  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  sw: any;

  // Tramites
  tramiteData: any [];

  constructor(private catalogosService: CatalogosService) { }

  ngOnInit(): void {
    if (this.load) {
      this.obtenerTramitesPendientes();
    } else {
      this.data.emit(this.tramiteData);
      if (this.tramiteData !== undefined) {
        localStorage.setItem('tp', String(this.tramiteData.length));
      } else {
        localStorage.setItem('tp', '0');
      }
    }
  }

  obtenerTramitesPendientes(): void {
    this.catalogosService.getTramitesPendientes().subscribe((tramite) => {
      if (tramite.length !== 0) {
        this.tramiteData = tramite;
        this.data.emit(this.tramiteData);
        localStorage.setItem('tp', String(this.tramiteData.length));
        if (this.tmsg) {
          this.code = 'tramites.warn.1';
          this.detalle = 'Posee <strong>' + String(tramite.length) + '</strong> solicitudes con procesos sin finalizar.' +
            ' Para continuar, revise la bandeja de <strong>Trámites Pendientes.</strong>';
        }
      } else {
        this.tramiteData = [];
        this.data.emit(this.tramiteData);
        localStorage.setItem('tp', '0');
      }
    });
  }

}
